import { Box, Button, Heading, Modal, Text, TextButton } from '@zillow/constellation-10';
import type { YourRentalContactSectionDto } from '@zg-rentals/ts-your-rental-api-client';

const CONTENT = {
  TITLE: 'Contact',
  LANDLORD_SUFFIX: 'Landlord',
  DONE_BUTTON: 'Done',
  CONTACT_BUTTON: 'Contact',
} as const;

type ContactIreneModalProps = {
  contactSection: YourRentalContactSectionDto;
};

const ContactIreneModal = ({ contactSection }: ContactIreneModalProps) => {
  const renderBody = () => {
    const { name, email, phone } = contactSection;
    return (
      <Box
        css={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: 'default',
        }}
      >
        <Box css={{ display: 'flex' }}>
          <Text textStyle="body-lg-bold">{name}</Text>
          <Text textStyle="body-lg">
            <span style={{ whiteSpace: 'pre' }}> </span>/ {CONTENT.LANDLORD_SUFFIX}
          </Text>
        </Box>
        <Box css={{ display: 'flex', flexDirection: 'column' }}>
          <Text textStyle="body">{email}</Text>
          {phone && <Text textStyle="body">{phone}</Text>}
        </Box>
      </Box>
    );
  };

  return (
    <Modal
      trigger={
        <TextButton data-testid="Header-ContactButton" aria-label={`Contact ${contactSection.name}`}>
          {`${CONTENT.CONTACT_BUTTON} ${contactSection.name}`}
        </TextButton>
      }
      size="md"
      scrollDocument
      header={
        <Heading data-testid="ContactIreneModal-Header" level={2}>
          {CONTENT.TITLE}
        </Heading>
      }
      body={renderBody()}
      footer={
        <Modal.Close>
          <Button
            data-testid="ContactIreneModal-FooterButton"
            emphasis="filled"
            size="md"
            aria-label="Close contact modal"
          >
            {CONTENT.DONE_BUTTON}
          </Button>
        </Modal.Close>
      }
    />
  );
};

export default ContactIreneModal;
